/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import ReactionModel from '@/models/reaction';
import classnames from 'classnames';
interface HandUpBtnProps {
  reaction?: ReactionModel;
  emo?: any;
  handUp?: any;
}

const HandUpBtn: React.FC<HandUpBtnProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    reaction: store.reaction,
  };
})(
  observer((props) => {
    const { reaction, handUp } = props;

    const { formatMessage } = useIntl();

    return (
      <div className={s.wrapper}>
        <span className={classnames(s.handUp, reaction?.handUp ? s.isActive : '')} onClick={handUp}>
          <img
            src={reaction?.handupSetting?.handUpStaticWebp}
            alt={formatMessage({ id: 'handup' })}
            className={s.hand}
            title={formatMessage({ id: 'handup' })}
          />
          <span className={s.text}>
            {reaction?.handUp ? formatMessage({ id: 'handoff' }) : formatMessage({ id: 'handup' })}
          </span>
        </span>
      </div>
    );
  })
);
export default HandUpBtn;
